import { CampaignTestModeBannerType } from 'src/models/Campaigns/testModeBanner';
import { ExpiredCampaignsResponseType } from 'src/models/Modals/expiredCampaigns';
import { ApiFunctionNoParamType, ApiFunctionType, httpGet, httpGetCancellable } from 'src/utils/http';

const getPath = (path: string) => `/campaigns/${path}`;

export const apiCanCreateCampaignFromTemplate = (): Promise<boolean> =>
  httpGet(getPath('CanCreateCampaignFromTemplate'));

export const apiCheckExpiredCampaigns = (): Promise<ExpiredCampaignsResponseType> =>
  httpGet(getPath('CheckExpiredCampaigns'));

export const enum CampaignSetupFromTemplateStatus {
  Success = 1,
  NeedMoreInformation = 2,
}
export const apiUseCampaignSetupFromTemplate: ApiFunctionType<
  { ID: number; IsCreatedByAdmin: boolean; OverridenOrganizationID?: number | null; OverridenUserID?: number | null },
  {
    PermanentUrl: string;
    Status: CampaignSetupFromTemplateStatus;
    ShowOfflineRaffleModal: boolean;
    ShowNonUsRaffleSweepstakesModal: boolean;
  }
> = httpGetCancellable(getPath('SetupFromTemplate'));

export const getTestModeBannerInfo: ApiFunctionType<{ campaignPermanentUrl: string }, CampaignTestModeBannerType> =
  httpGetCancellable(getPath('getTestModeInfo'));

export const apiCanCreateMyCampaign: ApiFunctionNoParamType<boolean> = httpGetCancellable(
  getPath('CanCreateMyCampaign')
);
